import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import ReactPixel from "react-facebook-pixel";

import { Provider } from "react-redux";
import { load } from "redux-localstorage-simple";
import store from "./redux/store.js";

import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "animate.css/animate.compat.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom"; // ⭐ ADD THIS

// ⭐ Safe localStorage load
let persistedState = {};
try {
  persistedState = load();
} catch (err) {
  persistedState = {};
}

// ⭐ INIT META PIXEL (ONCE)
const pixelId = "2896710680527879";
if (typeof window !== "undefined") {
  ReactPixel.init(pixelId);
  ReactPixel.pageView();
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Suspense
    fallback={
      <div className="flex justify-center items-center h-screen">
        <span className="loader"></span>
      </div>
    }
  >
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter> {/* ⭐ REQUIRED */}
          <App />
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  </Suspense>
);
